import React from 'react';
export var SuccessSVG = (React.createElement("g", null,
    React.createElement("path", { d: "M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4Z", fill: "#242D3D" }),
    React.createElement("path", { d: "M10.33 16.41L6.28998 12.37L7.70998 10.96L10.33 13.59L16.29 7.63L17.71 9.04L10.33 16.41Z", fill: "#242D3D" })));
